module.exports = "/images/Run better promotions-2 2.svg?d2fa460d03c74b0edebb8ea8064aecf0";